import { TAcquisitionProviderFacade } from "../../../facades/AcquisitionProviderFacade/useAcquisitionProviderFacade";
import { hasDefaultComponent } from "../../../utils/pageModelUtils";
import { TFieldValidationResult } from ".";

export const personalInformationFieldValidations = (validatingState: TAcquisitionProviderFacade): TFieldValidationResult => {
    const validationResult: TFieldValidationResult = {};

    if (
        hasDefaultComponent(
            'cob-corp-acquisition/components/creditonebank/plastic-card-design',
        ) && !validatingState.getSelectedCardId()
    ) {
        validationResult['SelectedCardId'] = 'RequiredField';
    }

    return validationResult;
};